import styled from 'styled-components';
import { colors } from '../../../../styles/common';

export const BadgetWrongRightAnswer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 4px;
  font-family: Manrope, sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;

  > p {
    margin: 0;
  }

  &.is-correct {
    background: ${colors.greenBackground};
    color: ${colors.green};
  }

  &.is-incorrect {
    background: ${colors.redBackground};
    color: ${colors.red};
  }
`;
